<template>
   <el-form ref="form" :rules="rules" :model="currForm" label-width="80px" label-position="left">
      <el-form-item label="名称" prop="name">
         <el-input :disabled="!edit" style="width: 300px" placeholder="最多20个字" v-model="currForm.name"></el-input>
         <span v-if="currForm.id">当前装配人数：{{ currForm.countUsed }}</span>
      </el-form-item>

      <el-form-item label="图案" prop="emoji">
         <div class="bezel">
            <div class="bezel-box" v-for="(item, index) in currForm.emojiList" :key="index">
               <el-button class="bezel-close" icon="circle-close" @click="tapDelete(index)"
                  :disabled="!edit"></el-button>
               <el-input class="bezel-input" placeholder="请输入名称" v-model="item.title" :disabled="!edit"></el-input>
               <div class="bezel-item">
                  <UploadImg :imgUrl.sync="item.url" :disabled="edit" />
               </div>
               <div class="bezel-tips">(尺寸：155*155，jpg、png)</div>
            </div>
            <el-button style="margin-bottom: 20px;" type="primary" @click="tapAdd" :disabled="!edit">添加</el-button>
         </div>
      </el-form-item>

      <el-form-item label="展示排序" prop="sort">
         <el-input-number :min="0" :disabled="!edit" v-model="currForm.sort"></el-input-number>
         <div>数字越大越靠前</div>
      </el-form-item>
      <el-form-item label="拥有学生">
         <SelectStudent ref="SelectStudentRef" :disabled="edit" :selectVal.sync="currForm.useType"
            :privileges="currForm.privilegeRole">
         </SelectStudent>
      </el-form-item>
      <el-form-item label="角标图片">
         <SUpload
            v-model="currForm.superscript"
            accept="image/*"
            type="drag"
            :size="50"
            :disabled="!edit"
            :show-file-list="false"
         />
         <div class="tips">尺寸建议40*40，最大50KB，优先SVG其次png</div>
      </el-form-item>
   </el-form>
</template>

<script>
import UploadImg from "../../../../../components/common/UploadImg.vue";
import SelectStudent from "./SelectStudent.vue";

export default {
   components: { UploadImg, SelectStudent },

   props: {
      form: {
         type: Object,
         default: () => ({}),
      },
      edit: {
         type: Boolean,
         default: true,
      },
   },

   data() {
      // 验证表情
      var validateEmoji = (rule, value, callback) => {
         let emptyUrls = this.currForm.emojiList.filter((item) => {
            return !item.url || item.url === ''
         })
         let emptyTitles = this.currForm.emojiList.filter((item) => {
            return !item.title || item.title === ''
         })
         if (emptyUrls.length > 0) {
            callback(new Error("请上传表情图"));
         } else if (emptyTitles.length > 0) {
            callback(new Error("请输入名称"));
         } else {
            callback();
         }
      };
      return {
         currForm: {
            useType: 0,
            emojiList: [{ title: '', url: '' }]
         },
         rules: {
            name: [{ required: true, message: "请输入名称", trigger: "blur" }],
            emoji: [{ required: true, validator: validateEmoji, trigger: "change" }],
            sort: [{ required: true, type: "number", message: "请输入排序", trigger: "change" }],
         },
      };
   },

   watch: {
      form: {
         handler(newValue, oldVal) {
            if (newValue.emojiList) {
               this.currForm = JSON.parse(JSON.stringify(newValue));
            }
            this.currForm.useType = newValue.useType;
            this.currForm.businessType = newValue.businessType;
         },
         deep: true,
         immediate: true,
      },
   },

   methods: {
      // 点击删除
      tapDelete(index) {
         if (this.currForm.emojiList.length <= 1) { return; }
         this.currForm.emojiList.splice(index, 1)
      },

      // 点击添加
      tapAdd() {
         if (this.currForm.emojiList.length >= 50) { return; }
         let tab = { title: '', url: '' }
         this.currForm.emojiList.push(tab)
      },

      // 保存
      submit(release = false) {
         this.$refs.form.validate(async (valid) => {
            if (valid) {
               const uids = this.$refs.SelectStudentRef.selectItemList.map(
                  (item) => item.uid
               );
               const params = {
                  name: this.currForm.name,
                  useType: this.currForm.useType,
                  sort: this.currForm.sort,
                  content: JSON.stringify(this.currForm.emojiList),
                  businessType: this.currForm.businessType,
                  status: this.currForm.status,
                  superscript: this.currForm.superscript,
               };
               if (this.currForm.useType === 1) {
                  params.uids = uids;
               } else if (this.currForm.useType === 2) {
                  params.privilegeRole = this.$refs.SelectStudentRef.selectPrivileges.join(',');
               }
               if (this.currForm.id) {
                  params.id = this.currForm.id;
               }
               const res = await this.$http({
                  url: this.$util.domain + "/adminapi/v1/personalizedComponents/addOrEdit",
                  method: "post",
                  body: JSON.stringify(params),
               });
               if (res.data.error === 10000) {
                  if (release) {
                     const response = await this.$http({
                        url: this.$util.domain + "/adminapi/v1/personalizedComponents/change",
                        method: "get",
                        params: {
                           id: res.data.data,
                           status: 3,
                        },
                     });
                     if (response.data.error === 10000) {
                        this.$message.success("操作成功");
                        this.$router.push("/yunying/userDiyPage");
                     } else {
                        this.$message.error(response.data.message || "操作失败");
                     }
                  } else {
                     this.$message.success("操作成功");
                     this.$router.push("/yunying/userDiyPage");
                  }
               } else {
                  this.$message.error(res.data.message || "操作失败");
               }
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
   },
};
</script>

<style scoped>
.bezel {
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
}

.bezel-box {
   min-width: 188px;
   margin-right: 20px;
   margin-bottom: 20px;
   border: 1px solid #bfcbd9;
   border-radius: 10px;
   display: flex;
   flex-direction: column;
   align-items: center;
}

.bezel-close {
   width: 44px;
   height: 34px;
   margin-top: -17px;
   margin-right: -20px;
   align-self: flex-end;
   background-color: rgba(255, 255, 255, 0.0);
   border-color: rgba(255, 255, 255, 0.0);
}

.bezel-input {
   width: 148px;
}

.bezel-item {
   margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// EmojiPack.vue?0021ca10